module.exports = __webpack_public_path__ + "media/images/flags/4x3/che-49d277c96aa20c9e6c01a8a14b568ce6.svg";